module.exports = __webpack_public_path__ + "img/IMG-20200722-WA0008.461949eb.jpg";